import { Box } from "@chakra-ui/react";
import Layout from "components/Layout";
import ProductAttributesMatrix from "components/Products/ProductAttributesMatrix";
import HeadTitle from "components/Shared/HeadTitle";

const PAGE_TITLE = "Product Attributes";

export default function ProductAttributesPage() {
  return (
    <Box
      display="flex"
      flexFlow="column"
      height="100%"
      width="100%"
      minH={0}
      p={0}
    >
      <HeadTitle title={PAGE_TITLE} />

      <Box display="flex" flexDirection="column" flex="1 1 100%" minH={0}>
        <ProductAttributesMatrix />
      </Box>
    </Box>
  );
}

ProductAttributesPage.getLayout = (page: React.ReactElement) => (
  <Layout isFullHeight display="flex" flexFlow="column">
    {page}
  </Layout>
);
